import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Row, Col, Button } from 'react-bootstrap';
import snakeCaseKeys from 'snakecase-keys';
import { withFormik, Field, Form, getIn } from 'formik';
import FormikCheckBox from '../../components/Utils/Input/FormikCheckBox';
import { FormikSelect, FormikNumber } from '../../components';
import { updateAdvanceSettingAdvancePaymentsRequest } from '../../requests/advanceSettings';

const FormAdvancePayment = ({ errors, touched, setFieldValue, values, isSubmitting }) => {
  const [paymentAmount, setPaymentAmount] = useState(
    values?.advanceSetting[0]?.text_value === 'false' || values?.advanceSetting[0]?.text_value === 't'
  );
  const [paymentPercentage, setPaymentPercentage] = useState(
    values?.advanceSetting[2]?.text_value === 'false' || values?.advanceSetting[2]?.text_value === 't'
  );
  const advancePaymentPercentageLimit = Array.from(Array(101), (e, i) => ({ label: i, value: i }));
  const limitDayAdvancePayment = Array.from(Array(28), (e, i) => ({ label: i + 1, value: i + 1 }));
  const advancePaymentPercentage = values?.advanceSetting[2]?.integer_value;
  const dayAdvancePayment = values?.advanceSetting[3]?.integer_value;
  const limitMailingDay = Array.from(Array(28), (e, i) => ({ label: i + 1, value: i + 1 }));
  const mailingDay = values?.advanceSetting[1]?.integer_value;

  return (
    <Row className="justify-content-center align-items-center h-100">
      <Col md={11}>
        <Form className="d-flex flex-column justify-content-end mt-2">
          <p>Seleccione si el Anticipo será pagado por un monto fijo o sobre un porcentaje del sueldo base.</p>
          <Row>
            <Col md={2} className="d-flex flex-column ">
              <Field name="advanceSetting[1]integer_value">
                {({ field }) => (
                  <FormikSelect
                    {...field}
                    label="Día de Apertura de Solicitudes"
                    options={limitMailingDay}
                    defaultValue={mailingDay}
                    onChange={data => setFieldValue(field.name, data ? data.value : '')}
                    error={getIn(errors, field.name)}
                    touched={getIn(touched, field.name)}
                    tooltipClass="ml-2 mt-2"
                    tooltipText="Día de envío de correo para la apertura de solicitudes"
                  />
                )}
              </Field>
            </Col>
            <Col md={{ span: 2, offset: 1 }} className="d-flex flex-column ">
              <Field name="advanceSetting[3]integer_value">
                {({ field }) => (
                  <FormikSelect
                    {...field}
                    label="Día de Cierre de Solicitudes"
                    options={limitDayAdvancePayment}
                    defaultValue={dayAdvancePayment}
                    onChange={data => setFieldValue(field.name, data ? data.value : '')}
                    error={getIn(errors, field.name)}
                    touched={getIn(touched, field.name)}
                    tooltipClass="ml-2 mt-2"
                    tooltipText="Día de envío de correo para el cierre de solicitudes"
                  />
                )}
              </Field>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col md={9} className="d-flex flex-column ">
              <Row className="align-items-end">
                <Col xs="2">
                  <Field name="advanceSetting[0]text_value">
                    {({ field }) => (
                      <FormikCheckBox
                        {...field}
                        field={field}
                        value={field.value === 'true' || field.value === true}
                        checked={field.value === 'true' || field.value === true}
                        label="Monto"
                        custom
                        onClick={() => {
                          const isChecked = field.value === 'true' || field.value === true;
                          const next = !isChecked;
                          setFieldValue('advanceSetting[0]text_value', next);
                          setFieldValue('advanceSetting[2]text_value', !next);
                          setPaymentAmount(!next);
                          setPaymentPercentage(next);
                          if (next) setFieldValue('advanceSetting[2]integer_value', 0);
                        }}
                      />
                    )}
                  </Field>
                </Col>
                <Col md={6}>
                  <Field name="advanceSetting[0]integer_value">
                    {({ field }) => (
                      <FormikNumber
                        {...field}
                        disabled={paymentAmount}
                        label="Monto máximo a solicitar $"
                        thousandSeparator=""
                        error={getIn(errors, field.name)}
                        touched={getIn(touched, field.name)}
                      />
                    )}
                  </Field>
                </Col>
              </Row>
              <Row className="align-items-center">
                <Col xs="2">
                  <Field name="advanceSetting[2]text_value">
                    {({ field }) => (
                      <FormikCheckBox
                        {...field}
                        field={field}
                        value={field.value === 'true' || field.value === true}
                        checked={field.value === 'true' || field.value === true}
                        label="Porcentaje"
                        custom
                        onClick={() => {
                          const isChecked = field.value === 'true' || field.value === true;
                          const next = !isChecked;
                          setFieldValue('advanceSetting[2]text_value', next);
                          setFieldValue('advanceSetting[0]text_value', !next);
                          setPaymentPercentage(!next);
                          setPaymentAmount(next);
                          if (next) setFieldValue('advanceSetting[0]integer_value', 0);
                        }}
                      />
                    )}
                  </Field>
                </Col>
                <Col md={6}>
                  <Field name="advanceSetting[2]integer_value">
                    {({ field }) => (
                      <FormikSelect
                        {...field}
                        label="Monto máximo a solicitar %"
                        tooltipText="Corresponde al sueldo base del empleado"
                        isDisabled={paymentPercentage}
                        options={advancePaymentPercentageLimit}
                        defaultValue={advancePaymentPercentage}
                        onChange={data => setFieldValue(field.name, data ? data.value : '')}
                        error={getIn(errors, field.name)}
                        touched={getIn(touched, field.name)}
                      />
                    )}
                  </Field>
                </Col>
              </Row>
            </Col>
            <Col md={3} className="d-flex flex-column">
              <Button type="submit" variant="primary" disabled={isSubmitting} className="w-100 mt-auto">
                GUARDAR
              </Button>
            </Col>
          </Row>
        </Form>
      </Col>
    </Row>
  );
};

const mapStateToProps = state => {
  const { user, currentEmployee } = state.auth;
  return { user, currentEmployee };
};

const initialValues = ({ advanceSetting }) => ({ advanceSetting });

const handleSubmit = (values, { props, setSubmitting }) => {
  const { dispatch, extraAction } = props;

  const base = (values.advanceSetting || []).map(s => ({
    id: s.id,
    code: s.code,
    text_value: s.text_value,
    integer_value: s.integer_value
  }));

  if (values['advanceSetting[0]text_value'] !== undefined) base[0].text_value = values['advanceSetting[0]text_value'];
  if (values['advanceSetting[0]integer_value'] !== undefined)
    base[0].integer_value = values['advanceSetting[0]integer_value'];

  if (values['advanceSetting[1]integer_value'] !== undefined)
    base[1].integer_value = values['advanceSetting[1]integer_value'];

  if (values['advanceSetting[2]text_value'] !== undefined) base[2].text_value = values['advanceSetting[2]text_value'];
  if (values['advanceSetting[2]integer_value'] !== undefined)
    base[2].integer_value = values['advanceSetting[2]integer_value'];

  if (values['advanceSetting[3]integer_value'] !== undefined)
    base[3].integer_value = values['advanceSetting[3]integer_value'];

  const amountIsOn = base[0].text_value === true || base[0].text_value === 'true';
  const percentIsOn = base[2].text_value === true || base[2].text_value === 'true';
  if (percentIsOn) base[0].integer_value = 0;
  if (amountIsOn) base[2].integer_value = 0;

  setSubmitting(true);
  updateAdvanceSettingAdvancePaymentsRequest({
    dispatch,
    params: snakeCaseKeys({ advanceSetting: base }),
    successCallback: () => setSubmitting(false)
  });
  extraAction();
};

export default withRouter(
  connect(mapStateToProps)(
    withFormik({
      mapPropsToValues: params => initialValues(params),
      enableReinitialize: true,
      handleSubmit
    })(FormAdvancePayment)
  )
);
